import React, { Component } from "react";
import PropTypes from "prop-types";
import "./ViewerAnimalTable.css"
import { withTranslation } from 'react-i18next';
//import moment from "moment";
import { localDate, localDateTime } from "../tools/jsprocedure";

class ViewerAnimalsTable extends Component {
    displayName = ViewerAnimalsTable.name

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    async componentDidMount() {
        const { animals } = this.props;
        this.initOpen(animals);
    }      
    

    initOpen = (animals) => {
        let { animalInfoOpen } = this.props;

        if (animals.length > 0 && animalInfoOpen.length === 0 ) { 
            let aTemp = []; 
            let sTemp = [];
            animals.map((animal, i) => { 
                aTemp[i] = false; 
                animal.sessions.map((session,  index) => sTemp[index] = false );
                return aTemp[i];
            });
            this.setState({ animalInfoOpen: aTemp, sessionInfoOpen: sTemp });
        } 
    }

    handleAnimalClick = (animal, i) => {
        const {  animalInfoOpen } = this.props;
        
        if (!animalInfoOpen[i]) { 
            const { handleAnimalSelect  } = this.props;
            let aTemp = animalInfoOpen;
            aTemp.fill(false);
            aTemp[i] = true;

            this.setState({ animalInfoOpen: aTemp});
        
            handleAnimalSelect(animal,i);
        }
    }

    handleSessionClick = (session, i) => {
        const { sessionInfoOpen, } = this.props;
        if (!sessionInfoOpen[i]) {

            const { handleSessionSelect } = this.props;

            let sTemp = sessionInfoOpen;
            sTemp.fill(false);
            sTemp[i] = true;
            this.setState({ sessionInfoOpen: sTemp });
            handleSessionSelect(session);
        }
        
    }

    handleSequenceClick = (sequence, i) => {
        const { handleSequenceSelect, selectedSequence } = this.props;
        if (sequence !== selectedSequence) {
            const { handleSequenceSelect } = this.props;
            handleSequenceSelect(sequence);
        }
    }
    
    renderItemsTable = (animals, animalInfoOpen, sessionInfoOpen, selectedSequence, t, languageSelected ) => {

        return (
            <div className="animalList" >

                {animals.map((animal, i) =>
                    <div className="animalContent" key={"a_" + animal.id }>
                        <div className={animalInfoOpen[i] ? "animalSelected" : "animal"} key={animal.id} onClick={() => this.handleAnimalClick(animal, i)  } > {animal.name}  </div>
                        <label className="owner"> 
                            {animal.owners.length > 0 ? <div> {this.props.t("Owner(s)")}: {animal.owners.map((owner, index) => owner.name + (index !== animal.owners.length - 1 ? ", " : ""))} </div> : this.props.t("Owner(s): (No owner)")  }
                        </label>
                        {animalInfoOpen[i] && animal.sessions.length > 0 ?
                            <div >
                                { animal.sessions.map((session,index) =>
                                    <div key={session.id}  >
                                        <div className={sessionInfoOpen[index] ? "sessionSelected" : "session"} onClick={() => this.handleSessionClick(session, index)} > {localDateTime(new Date(session.date), languageSelected)} </div>
                                        {sessionInfoOpen[index] && session.sequences.length > 0 ?
                                            <div >
                                                {session.sequences.map((sequence, index) =>
                                                    <div className={sequence === selectedSequence ? "sequenceSelected" : "sequence"} key={sequence.id} onClick={() => this.handleSequenceClick(sequence, index)}>
                                                        {localDate(new Date(sequence.date), languageSelected)}
                                                    </div>
                                                )
                                                }
                                            </div> : null
                                        }
                                    </div>
                                )}
                            </div> : null
                        }
                        {""}
                    </div>
                )}
            </div>
        );
    }      

    render() {

        const { animals, animalInfoOpen, sessionInfoOpen, selectedSequence, t, languageSelected}  = this.props

  

        return (
            <div>
                {animals.length > 0 ? this.renderItemsTable(animals, animalInfoOpen, sessionInfoOpen, selectedSequence, t, languageSelected)
                    : <p><em>{t("List is empty")}</em></p>}

            </div>
        );
    }

   
}

export default withTranslation()(ViewerAnimalsTable);

ViewerAnimalsTable.propTypes = {

    handleAnimalSelect: PropTypes.func.isRequired,
    handleOwnerSelect: PropTypes.func.isRequired,
    handleSessionSelect: PropTypes.func.isRequired,
    handleSequenceSelect: PropTypes.func.isRequired,
    animals: PropTypes.array.isRequired,
    animalInfoOpen: PropTypes.array.isRequired,
    sessionInfoOpen: PropTypes.array.isRequired,
    selectedSequence: PropTypes.object.isRequired,

}